import * as types from "../types"
import * as customFieldApi from "../../api/core/customFields.dd"
import { setPriority } from "os"
import { allResolved } from "q"
import { store } from "../store"
import Vue from "vue"

const state = {
  protectedCustomFields:[],
  allCustomFields:[],
  allCustomFieldTypes:[],
  allCustomFieldsMeta:{pagination:{}}
}

const getters = {
  [types.CUSTOM_FIELDS]: (state) => {
    return state.allCustomFields
  },
  [types.PROTECTED_CUSTOM_FIELDS]: (state) => {
    return state.protectedCustomFields
  },    
  [types.CUSTOM_FIELD_TYPES]: (state) => {
    return state.allCustomFieldTypes
  },
  [types.CUSTOM_FIELDS_PAGINATION]: (state) => {
    return state.allCustomFieldsMeta.pagination
  }  
}

const mutations = {
  [types.CUSTOM_FIELDS]: (state, payload) => { 
    state.allCustomFields = payload.data
    // only add pagination if it is found
    if(payload.meta.pagination){
      state.allCustomFieldsMeta = payload.meta    
    }
  },  
  [types.PROTECTED_CUSTOM_FIELDS]: (state, payload) => { 
    state.protectedCustomFields = payload.data
  },
  [types.CUSTOM_FIELD_TYPES]: (state, payload) => {
    state.allCustomFieldTypes = payload;
  },  
}

const actions = {
    [types.CUSTOM_FIELDS]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            customFieldApi.allCustomFields(payload.params).then((res) => {
                commit(types.CUSTOM_FIELDS, res)
                resolve(res.data)
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },
    [types.PROTECTED_CUSTOM_FIELDS]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          customFieldApi.protectedCustomFields(payload.params).then((res) => {
              commit(types.PROTECTED_CUSTOM_FIELDS, res)
              resolve(res.data)
          }).catch((e) => {
            reject(e.result)
          })
      })
      return p
  },    
    [types.CUSTOM_FIELD_TYPES]: ({ commit }, payload) => {
        let p = new Promise((resolve, reject) => {
            customFieldApi.allCustomFieldTypes(payload.params).then((res) => {
                commit(types.CUSTOM_FIELD_TYPES, res.data)
                resolve()
            }).catch((e) => {
              reject(e.result)
            })
        })
        return p
    },    
    [types.SAVE_CUSTOM_FIELD]: ({ commit }, payload) => {
      
        let p = new Promise((resolve, reject) => {
            customFieldApi.saveCustomField(payload.data).then((e) => {            
               resolve(e)
            }).catch((e) => {
               reject(e)
            })
        })
        return p
    },  
    [types.SAVE_CUSTOM_FIELD_ALLOWED_VALUE]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          customFieldApi.saveCustomFieldAllowedValue(payload.data).then((e) => {            
             resolve(e)
          }).catch((e) => {
             reject(e)
          })
      })
      return p
  },      
  [types.DELETE_CUSTOM_FIELD_ALLOWED_VALUE]: ({ commit }, payload) => {
      
    let p = new Promise((resolve, reject) => {
        customFieldApi.deleteCustomFieldAllowedValue(payload.data).then((e) => {            
           resolve(e)
        }).catch((e) => {
           reject(e)
        })
    })
    return p
},      
    [types.DELETE_CUSTOM_FIELD]: ({ commit }, payload) => {
      
      let p = new Promise((resolve, reject) => {
          customFieldApi.deleteCustomField(payload.data).then((e) => {            
              resolve(e)
          }).catch((e) => {
            reject(e)
          })
      })
      return p
    },
    [types.CUSTOM_FIELD_SEARCH]: ({ commit }, payload) => {
      let p = new Promise((resolve, reject) => {
          customFieldApi.searchCustomFields(payload.data, payload.params).then((res) => {              
              commit(types.CUSTOM_FIELDS, res)
              resolve()
          }).catch((e) => {
            reject(e.data)
          })
      })
      return p
    },    
    [types.SAVE_CUSTOM_FIELDS_ON_ASSET_GROUP]: ({ commit }, payload) => {      
      let p = new Promise((resolve, reject) => {
          customFieldApi.saveCustomFieldsOnAssetGroup(payload.data).then((e) => {            
             resolve(e)
          }).catch((e) => {
             reject(e)
          })
      })
      return p
    }
}

export default {
  state,
  getters,
  mutations,
  actions
}
